import App from 'App'
import DrupalContext from 'contexts/DrupalContext'
import daysjsInit from 'helpers/daysjsInit'
import i18nInit from 'helpers/i18n'
import 'helpers/polyfills'
import React from 'react'
import { createRoot } from 'react-dom/client'
import AppStore from 'stores/App'
import { FetchProvider } from './contexts/FetchContext'
(() => {
  // Initialize (each) search application with config from attributes
  const applications = document.getElementsByClassName('gu-search-experience')

  if (!applications.length) {
    return console.error('Failed to render Search application', {
      reason: 'No elements with class gu-search-experience',
    })
  }

  // Get values from element attributes and pass as props to App
  Array.from(applications).forEach((appRootElement) => {
    const settings = [
      'searcher-id',
      'searcher-type',
      'searcher-path',
      'searcher-preamble',
      'searcher-exposed-tabs',
      'searcher-endpoint',
      'searcher-completer',
      'searcher-name', // only when niche
      'searcher-domains',
      'language',
      'node-id',
    ].map((attr) => appRootElement.getAttribute(`data-${attr}`) || undefined)

    let [
      id,
      type,
      path,
      preamble,
      exposed_tabs,
      endpoint,
      completer,
      niche,
      domains,
      language,
      node_id,
    ] = settings

    niche = niche !== 'global' ? niche : undefined // TODO: fix in backend

    i18nInit(language)
    daysjsInit(language)

    window.react = {
      drupal: {
        id,
        type,
        path,
        preamble,
        exposed_tabs,
        endpoint,
        completer,
        niche,
        domains,
        language,
        node_id,
      },
    }
    const root = createRoot(appRootElement)
    root.render(
      <AppStore>
        <FetchProvider>
          <DrupalContext.Provider value={window.react.drupal}>
            <App />
          </DrupalContext.Provider>
        </FetchProvider>
      </AppStore>
    )
  })
})()
